import { Component, OnInit } from '@angular/core';
declare let $:any;
@Component({
  selector: 'app-mastermodule',
  templateUrl: './mastermodule.component.html',
  styleUrls: ['./mastermodule.component.css']
})
export class MastermoduleComponent implements OnInit {
  loginresponse:any;
  userrole:any;
  farm_userrole:any;
  isHiddenguest:boolean=false;
  isHidden:boolean=false;
  constructor() { }

  ngOnInit(): void {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.farm_userrole){
      this.isHidden=true;
      this.isHiddenguest=true;
    }
    /*if(this.userrole==1){
      this.isHiddenguest=true;
    }*/
  }

}
